// skipcq: JS-W1028, JS-0128
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import DashboardSectionInfo from './DashboardSectionInfo';
import DashboardSurfaceCard from './DashboardSurfaceCard';

function DashboardMetricPanel({ title, infoContent, children }) {
  return (
    <DashboardSurfaceCard>
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 2 }}>
          <Typography variant="h6" component="h2" sx={{ mb: 0 }}>
            {title}
          </Typography>
          {infoContent ? (
            <DashboardSectionInfo aria-label={`About ${title}`}>
              {infoContent}
            </DashboardSectionInfo>
          ) : null}
        </Box>
        {children}
      </CardContent>
    </DashboardSurfaceCard>
  );
}

DashboardMetricPanel.propTypes = {
  title: PropTypes.string.isRequired,
  infoContent: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default DashboardMetricPanel;
